import {HeadingPlugin} from "@udecode/plate-heading/react";
import {BlockquotePlugin} from "@udecode/plate-block-quote/react";
import {BoldPlugin, ItalicPlugin} from "@udecode/plate-basic-marks/react";
import {ListPlugin} from "@udecode/plate-list/react";
import {SoftBreakPlugin} from "@udecode/plate-break/react";
import {LinkPlugin} from "@udecode/plate-link/react";
import {HorizontalRulePlugin} from "@udecode/plate-horizontal-rule/react";
import {CursorOverlayPlugin} from "@udecode/plate-selection/react";
import {ParagraphPlugin} from "@udecode/plate/react";
import {CursorOverlay} from "../CursorOverlay";
import {FloatingLinkEditor} from "../FloatingLinkEditor";
import {isMissingProtocol} from "../../../utils/SchoolBlocksUtilities";
import {capitalize} from "../../../utils/StringUtilities";
import {DocxPlugin} from "@platejs/docx";

type attributesToPreserve = "class" | "id" | "style" | "height" | "width" | "alt" | "src" | "title";
export const preserveAttributes: attributesToPreserve[] = ["class", "id", "style", "height", "width", "alt", "src", "title"];

export function attributesToJsx(attributes: Partial<{[key in attributesToPreserve]: any}> = {}) {
    const jsx = {}
    for (let [k, v] of Object.entries(attributes)) {
        switch(k) {
            case "class":
                jsx["className"] = v;
                break;
            case "style":
                jsx["style"] = v.split(",").map(v => v.trim()).reduce((acc, curr) => {
                    const [key, value] = curr.split(":").map(v => v.trim());
                    // convert kebab case to camel case
                    acc[key.split("-").map((w, i) => {
                        return i > 0 ? capitalize(w) : w;
                    }).join("")] = value;
                    return acc;
                }, {})
                break;
            default:
                jsx[k] = v;
        }
    }
    return jsx;
}

export const basePlatePlugins = [
    ParagraphPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    HeadingPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    BlockquotePlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    BoldPlugin,
    ItalicPlugin,
    ListPlugin.configure({
        parsers: {
            html: {
                deserializer: {
                    attributeNames: preserveAttributes,
                }
            }
        }
    }),
    SoftBreakPlugin.configure({
        options: {
            rules: [
                {hotkey: 'shift+enter'},
            ],
        },
    }),
    LinkPlugin.extend({
        render: { afterEditable: () => <FloatingLinkEditor />},
        options: {
            transformInput: (url) => {
                if (isMissingProtocol(url)) {
                    url ="https://" + url;
                }
                return url;
            },
            parsers: {
                html: {
                    deserializer: {
                        attributeNames: preserveAttributes,
                    }
                }
            }
        }
    }),
    HorizontalRulePlugin,
    CursorOverlayPlugin.configure({
        render: ({afterEditable: () => <CursorOverlay />})
    }),
    DocxPlugin,
];